export const CATEGORY = ['Food', 'Entertainment', 'Travel', 'Others'];

export const PER_PAGE = 3;
